import { AxiosResponse } from "axios";
import { put, call, throttle } from "redux-saga/effects";
import {
  failedUserGivenDetails,
  failedDeleteLocation,
  successDeleteLocation,
  successUserGivenDetails,
  updateDeleteLocation,
  failedaddFavRestaurants,
  successaddFavRestaurants,
  userActions,
  editEmailRequest,
  editEmailSuccess,
  editEmailFailure,
  setPromoConsentSuccess,
  setPromoConsentFailure,
  getUserGivenDetails,
  updateUserDetailsSuccess,
  updateUserDetailsFailure,
  usedMobileorEmail,
} from "./userActions";
import {
  getUserDetails,
  updateLocationDetails,
  addFavRestaurant,
  updateEmail,
  promoConsent,
  updateUserDetails,
} from "./userAPI";
import {
  USERGIVEN_DETAIL_REQUEST,
  LOCATION_DELETE_REQUEST,
  ADD_FAV_RESTAURANT,
  EDIT_EMAIL_REQUEST,
  SET_PROMO_CONSENT_REQUEST,
  UPDATE_USER_DETAILS_REQUEST,
} from "./userConstants";
import {
  AddFavRestaurants,
  LocationDetails,
  UpdateUserDetailsPayload,
  UserGivenDetail,
} from "./userModels";
import { decryptJson } from "../../utils/react-ec-utils";
import {  GUEST_EMAIL, GUEST_MOBILE_NUMBER, GUEST_USER_NAME,  USER_DETAILS, USER_ID } from "../../constants";
import { showErrorToast, showErrorToastDesktop } from "../../utils/toastUtils";
import { useSelector } from "react-redux";
import { updateProfileFailure } from "../auth/AuthActions";
import { setCookie } from "../../../helper/cookieHelper";

function* getUserGivenDetailsSaga(action: userActions) {
  try {
    const response: AxiosResponse = yield call(getUserDetails);
    const decryptedData = decryptJson(response?.data?.encryptedText);
    if (response.status === 200) {
      yield put(successUserGivenDetails(decryptedData));
    }
  } catch (err) {
    yield put(failedUserGivenDetails());
  }
}

function* deleteUserLocation(action: userActions) {
  try {
    const response: AxiosResponse = yield call(
      updateLocationDetails,
      action.payload as LocationDetails
    );
    if (response.status === 200) {
      yield put(successDeleteLocation(response.data));
      yield put(getUserGivenDetails());
    }
  } catch (err) {
    yield put(failedDeleteLocation({ message: "Please Try Again" }));
  }
}

function* addFavRest(action: userActions) {
  try {
    const response: AxiosResponse = yield call(
      addFavRestaurant,
      action.payload as AddFavRestaurants
    );
    if (response.status === 200) {
      yield put(successaddFavRestaurants(response.data));
    }
  } catch (err) {
    yield put(failedaddFavRestaurants({ message: "Please Try Again" }));
  }
}

function* editEmail(action: userActions) {
  try {
    const response: AxiosResponse = yield call(
      updateEmail,
      action.payload as string
    );
    if (response.status === 200) {
      yield put(editEmailSuccess(response.data));
    }
  } catch (err) {
    yield put(editEmailFailure("Please Try Again"));
  }
}

// For Promotional Messages

function* setPromoConsentSaga(action: userActions) {
  try {
    const response: AxiosResponse = yield call(
      promoConsent,
      action.payload as number
    );
    if (response.status === 200) {
      yield put(setPromoConsentSuccess());
    }
  } catch (err) {
    yield put(setPromoConsentFailure("Please Try Again"));
  }
}

// For User Details Update
function* updateUserDetailsSaga(action: userActions) {
  const isMobile = window.innerWidth <= 768; 
  try {
    const response: AxiosResponse = yield call(
      updateUserDetails,
      action.payload as UpdateUserDetailsPayload
    );

    if (response.status === 200) {
      // After successful update, fetch the updated user details
      
   
       const decryptedResponse = decryptJson(response?.data?.encryptedText);
       yield put(getUserGivenDetails());
      yield put(updateUserDetailsSuccess(decryptedResponse));
            localStorage.removeItem(GUEST_EMAIL);
            localStorage.removeItem(GUEST_MOBILE_NUMBER);
            localStorage.removeItem(GUEST_USER_NAME);
            // response.data?.body?.customerDetails&&localStorage.setItem(USER_DETAILS, JSON.stringify(response.data?.body?.customerDetails));
            decryptedResponse?.body?.customerDetails && setCookie(USER_DETAILS, decryptedResponse?.body?.customerDetails);
            // Storing Auth Details
            // response.data?.body?.customerDetails?.customerId && localStorage.setItem(USER_ID, response.data?.body?.customerDetails?.customerId);
            decryptedResponse?.body?.customerDetails?.customerId && setCookie(USER_ID, decryptedResponse?.body?.customerDetails?.customerId);
            //TOOD: remove the below
    } else {
      if (response.status === 400 && response?.data?.message?.includes('linked')) {
        if (response?.data?.message?.includes('number is linked')) {
          yield put(usedMobileorEmail(action.payload.mobilePhone));
        } else {
          yield put(usedMobileorEmail(action.payload.email));
        }
      }

      if (isMobile) {
        showErrorToast(response?.data?.message);
      } else {
        showErrorToastDesktop(response?.data?.message);
      }

     yield put(updateProfileFailure(response.data?.message));
    }
  } catch (err) {
  yield put(updateProfileFailure(err));
  }
}

export default function* userSaga() {
  yield throttle(3000, USERGIVEN_DETAIL_REQUEST, getUserGivenDetailsSaga);
  yield throttle(3000, ADD_FAV_RESTAURANT, addFavRest);
  yield throttle(3000, LOCATION_DELETE_REQUEST, deleteUserLocation);
  yield throttle(3000, EDIT_EMAIL_REQUEST, editEmail);
  yield throttle(3000, SET_PROMO_CONSENT_REQUEST, setPromoConsentSaga);
  yield throttle(3000, UPDATE_USER_DETAILS_REQUEST, updateUserDetailsSaga);
}
